const indexItems = [
  { id: 1, label: '国产剧', icon: 'ri-tv-2-line', count: '5860部', color: 'bg-primary-100 text-primary-600' },
  { id: 2, label: '韩剧', icon: 'ri-heart-line', count: '2340部', color: 'bg-accent-100 text-accent-700' },
  { id: 3, label: '美剧', icon: 'ri-global-line', count: '1890部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, label: '电影', icon: 'ri-film-line', count: '4120部', color: 'bg-primary-100 text-primary-600' },
  { id: 5, label: '动漫', icon: 'ri-emotion-line', count: '1780部', color: 'bg-accent-100 text-accent-700' },
  { id: 6, label: '综艺', icon: 'ri-mic-line', count: '960部', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, label: '日剧', icon: 'ri-sun-line', count: '820部', color: 'bg-primary-100 text-primary-600' },
  { id: 8, label: '纪录片', icon: 'ri-camera-line', count: '650部', color: 'bg-accent-100 text-accent-700' },
  { id: 9, label: '少儿', icon: 'ri-star-line', count: '430部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            分类大全
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按类型浏览，快速找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-9 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#index-${item.id}`}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}